import { Booking } from "PFTypes";
import { createContext, useContext } from "react";

// in the future we could move here more dnd related state
// when adding more values, be careful - it could have performance impact
export type BookingDndState = {
  draggedBookingId: number | null;
};

export type BookingDndApi = {
  setDraggedBookingId: (id: number | null) => void;
  checkCanDragVertically: (booking: Booking) => boolean;
};

const INITIAL_BOOKING_DND_STATE: BookingDndState = {
  draggedBookingId: null
};

const INITIAL_BOOKING_DND_API: BookingDndApi = {
  setDraggedBookingId: () => {},
  checkCanDragVertically: () => false
};

export const BookingDndStateContext = createContext<BookingDndState>(INITIAL_BOOKING_DND_STATE);
export const BookingDndApiContext = createContext<BookingDndApi>(INITIAL_BOOKING_DND_API);

export const useBookingDndStateContext = () => useContext(BookingDndStateContext);
export const useBookingDndApiContext = () => useContext(BookingDndApiContext);
